export default {
      id: "arrowLeft-usage",
      viewBox: "0 0 112.356 110.606",
      url: "../../assets/" + "sprite.svg#arrowLeft-usage",
      toString: function () {
        return this.url;
      }
    }